// Derives the online/offline signal from the platform (browser `navigator.onLine` +
// online/offline events; RN supplies its own). Defaults to online where unavailable.
export const makeConnectivity = () => ({
    observeConnectivity: () => ({
        subscribe(next) {
            const g = globalThis;
            next(g.navigator?.onLine ?? true);
            if (typeof g.addEventListener !== "function")
                return () => { };
            const on = () => next(true);
            const off = () => next(false);
            g.addEventListener("online", on);
            g.addEventListener("offline", off);
            return () => {
                g.removeEventListener?.("online", on);
                g.removeEventListener?.("offline", off);
            };
        },
    }),
});
//# sourceMappingURL=connectivity.repo.js.map